import { MATCH_ID, TOURNAMENT_ID } from "../config/tournament";

export const buildNavigationUrl = (
  url: string,
  options?: { matchId?: string }
) => {
  const href = window.location.href;
  const tournamentId = getValueFromUrl(href, "tournamentId") || TOURNAMENT_ID;
  const matchId = options?.matchId || getValueFromUrl(href, "matchId") || MATCH_ID;
  const accessToken = getValueFromUrl(href, "accessToken");

  const queryParams = [
    tournamentId && `tournamentId=${tournamentId}`,
    matchId && `matchId=${matchId}`,
    accessToken && `accessToken=${accessToken}`,
  ]
    .filter(Boolean)
    .join("&");

  return queryParams ? `${url}?${queryParams}` : url;
};

const normalizeUrl = (url: string): string => {
  // Fix malformed URLs where & is used instead of ? for first query parameter
  const ampersandIndex = url.indexOf("&");
  const questionIndex = url.indexOf("?");

  // If & comes before ? or there's no ?, replace first & with ?
  if (
    ampersandIndex !== -1 &&
    (questionIndex === -1 || ampersandIndex < questionIndex)
  ) {
    return url.replace("&", "?");
  }

  return url;
};

const extractQueryString = (url: string): string => {
  const normalizedUrl = normalizeUrl(url);
  const questionIndex = normalizedUrl.indexOf("?");

  return questionIndex !== -1 ? normalizedUrl.substring(questionIndex + 1) : "";
};

const parseQueryParams = (queryString: string): URLSearchParams => {
  return new URLSearchParams(queryString);
};

export const getValueFromUrl = (url: string, key: string): string | null => {
  try {
    const queryString = extractQueryString(url);
    if (!queryString) return null;

    const params = parseQueryParams(queryString);
    return params.get(key);
  } catch (error) {
    console.warn("Failed to parse URL parameter:", error);
    return null;
  }
};
